<template>
  <b-card title="Araç Bilgisi">
    <b-table-simple bordered>
      <b-tbody>
        <b-tr>
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Marka Model
          </b-td>
          <b-td>
            {{ swapcar.swap_brand }} {{ swapcar.swap_model }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Donanım Paketi
          </b-td>
          <b-td>
            {{ swapcar.hardware }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Model Yılı
          </b-td>
          <b-td>
            {{ swapcar.model_year }}
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.engine_type">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Motor Tipi
          </b-td>
          <b-td>
            {{ swapcar.engine_type }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Motor Gücü (Hp)
          </b-td>
          <b-td>
            {{ swapcar.hp }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Silindir Hacmi
          </b-td>
          <b-td>
            {{ swapcar.cc }} cc
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.swapcar_type">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Kasa Tipi
          </b-td>
          <b-td>
            {{ swapcar.swapcar_type }}
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.km">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Km
          </b-td>
          <b-td>
            {{ swapcar.km | toNumber }} km
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.fuel">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Yakıt Tipi
          </b-td>
          <b-td>
            {{ swapcar.fuel }}
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.gear">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Vites Tipi
          </b-td>
          <b-td>
            {{ swapcar.gear }}
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.color">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Renk
          </b-td>
          <b-td>
            {{ swapcar.color }} {{ swapcar.color_type? '(' + swapcar.color_type + ')' : null }}
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.car_type">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Araç Tipi
          </b-td>
          <b-td>
            {{ swapcar.car_type }}
          </b-td>
        </b-tr>
        <b-tr v-if="swapcar.license_plate">
          <b-td
            class="bg-light font-weight-bold text-primary"
            width="200"
          >
            Plaka
          </b-td>
          <b-td>
            {{ swapcar.license_plate }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-row>
      <b-col
        cols="12"
        class="font-weight-bold my-1 font-medium-2 text-primary"
      >
        Araç Özellikleri
      </b-col>
      <b-col
        v-for="item in swapcar.accessories"
        :key="item.id"
        cols="12"
        md="6"
        class="mb-1"
      >
        <FeatherIcon
          icon="CheckIcon"
          class="text-success"
        />
        {{ item.title }}
      </b-col>
    </b-row>
    <b-list-group v-if="false">
      <list-item
        title="Model Yılı"
        :value="swapcar.model_year"
      />
      <template>
        <list-item
          title="Marka"
          :value="swapcar.swap_brand"
        />
        <list-item
          title="Model"
          :value="swapcar.swap_model"
        />
      </template>
      <list-item
        title="Kasa Tipi"
        :value="swapcar.swapcar_type"
      />
      <list-item
        title="Silindir Hacmi"
        :value="swapcar.cc"
      />

      <list-item
        title="Motor Gücü (Hp)"
        :value="swapcar.hp"
      />
      <list-item
        title="Donanım Paketi"
        :value="swapcar.hardware"
      />
      <list-item
        title="Km"
        :value="swapcar.km"
      />
      <list-item
        title="Yakıt Tipi"
        :value="swapcar.fuel"
      />
      <list-item
        title="Vites"
        :value="swapcar.gear"
      />
      <list-item
        title="Renk"
        :value="swapcar.color"
      />
      <list-item
        title="Plaka"
        :value="swapcar.license_plate"
      />
      <!-- old-->
    </b-list-group>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup, BTableSimple, BTbody, BTr, BTd, BRow, BCol,
} from 'bootstrap-vue'
import ListItem from '@/views/Expertise/Components/ListItem.vue'

export default {
  name: 'Public',
  components: {
    BCard,
    BListGroup,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BRow,
    BCol,
    ListItem,
  },
  computed: {
    swapcar() {
      return this.$store.getters['swapcars/getSwapcar']
    },
  },
}
</script>

<style scoped></style>
